export default {
    filters: {
        /**s
         * Split the ISO date format into date
         * Eg: 2019-08-24T00:00:00Z => 2019-08-24
         * @param date
         * @returns {*}
         */
        iso_to_date: function (date) {
            return date.split("T")[0];
        },

        /**
         * Convert the value into money format
         * @param value
         * @returns {string}
         */
        money: function (value) {
            // add fixed decimal point and convert into the money format. This will give string type
            let money = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            // split the string by the .
            let split = money.split(".");
            // if the value after . is more than 0, then return the value
            if (parseFloat(split[1]) > 0) {
                return split.join('.');
            }
            // else remove the decimal point
            return split[0];
        },
        truncate: function (text, length, clamp) {
            length = length || 9;
            clamp = clamp || '...';
            if (!text || text.length <= length) return text;
            let tcText = text.slice(0, length);
            return tcText + clamp;
        }
    }
}

// Vue.filter('truncate', function (text, length, clamp) {
//     clamp = clamp || '...';
//     length = length || 30;
//
//     if (text.length <= length) return text;
//
//     var tcText = text.slice(0, length - clamp.length);
//     var last = tcText.length - 1;
//
//
//     while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;
//
//     // Fix for case when text dont have any `space`
//     last = last || length - clamp.length;
//
//     tcText =  tcText.slice(0, last);
//
//     return tcText + clamp;
// });
